import { Box, Link, Stack, Text } from '@chakra-ui/react';

import { buildBusinessEmailTemplate, ENTERPRISE_OVERVIEW_URL } from '../utils/email-templates';

import { CopyToText } from './copy-to-text';
import { HelpCta } from './help-cta';
import { BusinessPlanPictogram } from './reimbursement-pictograms';
import { SectionHeading } from './section-heading';

export function BusinessPlanSection() {
  return (
    <Stack as='section' color='grey.700' gap={8}>
      <SectionHeading
        colorScheme='blue'
        pictogram={<BusinessPlanPictogram />}
        title='Ask your employer to sign up for a business plan'
      />
      <Text fontSize='16px' lineHeight='1.5'>
        Alternatively, your company can sign up for a business plan, purchasing subscriptions for you and your
        colleagues directly. Here is an example email template you can use to let your manager know about Udacity
        business plans for your team’s education.
      </Text>
      <CopyToText label='Email For Business Plan' name='business-template' text={buildBusinessEmailTemplate()}>
        <Box display='flex' flexDirection='column' fontSize='16px' gap={6} lineHeight='1.5'>
          <Text>
            Hi{' '}
            <Text as='span' color='blue.500' fontWeight='600'>
              [manager name]
            </Text>
            ,
          </Text>
          <Text>
            I’ve been researching professional education platforms for our team, and would like to share information
            with you about the best one I found, Udacity. Programs at Udacity consist of a high-quality, meticulously
            designed curriculum, built in collaboration with companies like Google, Facebook, Amazon, Adobe, and
            Microsoft.
          </Text>
          <Text>
            Here are links to a few of the programs I think would have the biggest impact for us{' '}
            <Text as='span' color='blue.500' fontWeight='600'>
              [link to program pages]
            </Text>
            .
          </Text>
          <Text>
            Udacity’s learning subscription is unique because the team would learn via hands-on projects that would
            allow us to apply our new skills in the workplace immediately. We’d also have access to a mentor network
            comprised of industry experts we could get feedback from throughout our learning journeys.
          </Text>
          <Text>
            Providing a subscription to our team will help us by{' '}
            <Text as='span' color='blue.500' fontWeight='600'>
              [list reasons]
            </Text>
          </Text>
          <Text>
            A Udacity subscription gets the team access to every program on their platform from schools such as
            Artificial Intelligence, Data Science, and Programming. We will be able to expand our knowledge in multiple
            areas through continuous education.
          </Text>
          <Text>
            You can learn more about how Udacity helps entire teams upskill and why this would be great for our
            development here:{' '}
            <Link color='blue.500' href={ENTERPRISE_OVERVIEW_URL} textDecoration='underline' isExternal>
              {ENTERPRISE_OVERVIEW_URL}
            </Link>
          </Text>
          <Text>What are your thoughts?</Text>
          <Text>
            Thanks,
            <br />
            <Text as='span' color='blue.500' fontWeight='600'>
              [Your Name]
            </Text>
          </Text>
        </Box>
      </CopyToText>
      <HelpCta />
    </Stack>
  );
}
